/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StbGroupNameResponse
 */
export interface StbGroupNameResponse {
    /**
     * 
     * @type {string}
     * @memberof StbGroupNameResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof StbGroupNameResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof StbGroupNameResponse
     */
    deviceTypeName?: string;
    /**
     * 
     * @type {string}
     * @memberof StbGroupNameResponse
     */
    scope?: string;
}

export function StbGroupNameResponseFromJSON(json: any): StbGroupNameResponse {
    return StbGroupNameResponseFromJSONTyped(json, false);
}

export function StbGroupNameResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StbGroupNameResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'deviceTypeName': !exists(json, 'deviceTypeName') ? undefined : json['deviceTypeName'],
        'scope': !exists(json, 'scope') ? undefined : json['scope'],
    };
}

export function StbGroupNameResponseToJSON(value?: StbGroupNameResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'deviceTypeName': value.deviceTypeName,
        'scope': value.scope,
    };
}

